/**
 * TAPD
 * 1. https://tapd.woa.com/tapd_fe/20396022/story/detail/1020396022886500609
 * 2. https://tapd.woa.com/tapd_fe/20396022/story/detail/1020396022886126667
 */

import { IPlugin, Core } from 'trtc-js-sdk-core/src/plugin';
import { ValidateRule } from 'trtc-js-sdk-core/src/utils/decorators/validate';
import { KV_REPORT_KEY_DEBUG_PLUGIN } from 'trtc-js-sdk-core/src/manager/kv-stat-manager';
import { version } from 'trtc-js-sdk-core/src/common/constants';
import { name } from '../../../package.json';

// 修改 debug-dialog.ts 后需要本地测试时，取消注释下方代码
// import TRTCDebugDialog from './debug-dialog';

let dmSeq = 0;
let loadScriptPromise: Promise<unknown>;

export class DebugPlugin implements IPlugin {
  static Name = 'Debug';
  static autoStart = true;

  private _core: Core;
  private log: Core['log'];
  private dialog: any | null;

  constructor(public core: Core) {
    this._core = core;
    this.log = core.log.createChild({ id: `${this.getAlias()}${++dmSeq}` });
    this.log.info('created');
  }

  getName() {
    return DebugPlugin.Name;
  }

  getAlias() {
    return 'dm'; // alias for 'debug mode'
  }

  getGroup() {
    return 'dm';
  }

  getValidateRule(method: 'start' | 'update' | 'stop'): ValidateRule {
    switch (method) {
      case 'start':
        return {
          name: 'StartDebugOptions',
          required: false
        };
      case 'update':
        return {
          name: 'UpdateDebugOptions',
          required: false
        };
      case 'stop':
        return {
          name: 'StopDebugOptions',
          required: false
        };
    }
  }

  async start() {
    const params = new URLSearchParams(location.search);
    /* 展示弹窗:
     * 1. 设置URL参数 `?trtcDebug=true`
     * 2. 设置会话存储 sessionStorage.setItem('TRTC_ENABLE_DEBUG_PLUGIN', 'true')
     * 3. 更新插件 trtc.updatePlugin('Debug', { visible: true })
     */
    if (!params.has('trtcDebug')) {
      const storage = window.sessionStorage?.getItem('TRTC_ENABLE_DEBUG_PLUGIN');
      if (storage !== 'true') return;
    }
    await this.openDebugDiaLog();
  }

  async update({ visible }: { visible: boolean }) {
    if (visible) {
      await this.openDebugDiaLog();
    } else {
      this.closeDebugDiaLog();
    }
  }

  stop() {
    this.closeDebugDiaLog();
  }

  destroy() {
    this.stop();
  }

  async openDebugDiaLog() {
    if (this.dialog) return;
    try {
      if (loadScriptPromise) {
        await loadScriptPromise;
      } else {
        const scriptPath = (new URLSearchParams(location.search)).get('trtcDebugDialogPath') || window.sessionStorage?.getItem('TRTC_DEBUG_DIALOG_PATH') || `https://unpkg.com/${name}@${version}/assets/debug-dialog.js`;
        loadScriptPromise = this._core.fileDownloader.loadScript(scriptPath);
        await loadScriptPromise;
      }
      // @ts-ignore
      this.dialog = new TRTCDebugDialog(this._core, this.log);
      this._core.kvStatManager.addSuccessEvent({ key: KV_REPORT_KEY_DEBUG_PLUGIN.LOAD_SCRIPT });
    } catch (e) {
      this._core.kvStatManager.addFailedEvent({ key: KV_REPORT_KEY_DEBUG_PLUGIN.LOAD_SCRIPT });
      this.log.error('load debug dialog script failed: ', JSON.stringify(e));
    }
  }

  closeDebugDiaLog() {
    if (!this.dialog) return;
    this.dialog.closeDialog();
    this.dialog = null;
  }
}
